import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Using `}<inlineCode parentName="p">{`identify`}</inlineCode>{`, you can capture identified events associated with specific users. This enables you to understand how they're using your product across different sessions, devices, and platforms.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.identify(
    'distinct_id', // Required. Replace 'distinct_id' with your user's unique identifier
    { email: 'max@hedgehogmail.com', name: 'Max Hedgehog' },  // $set, optional
    { first_visited_url: '/blog' } // $set_once, optional
);
`}</code></pre>
    <p>{`Calling `}<inlineCode parentName="p">{`identify`}</inlineCode>{` creates a person profile if one doesn't exist already. This means all events for that distinct ID count as identified events.`}</p>
    <p>{`You can get the distinct ID of the current user by calling `}<inlineCode parentName="p">{`posthog.get_distinct_id()`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      